module.exports = [
  {
    config: {
      path: "en",
      code: "en",
      ogLang: "en",
      name: "English",
      label: "English",
      isDefault: true,
    },
    translation: {},
  },
  {
    config: {
      path: "es",
      code: "es",
      ogLang: "es",
      name: "Spanish",
      label: "Español",
    },
    translation: {},
  },
  {
    config: {
      path: "ar",
      code: "ar",
      ogLang: "ar",
      name: "Arabic",
      label: "العربية",
    },
    translation: {},
  },
  {
    config: {
      path: "zh",
      code: "zh",
      ogLang: "zh",
      name: "Chinese",
      label: "中文",
    },
    translation: {},
  },
  {
    config: {
      path: "fr",
      code: "fr",
      ogLang: "fr",
      name: "French",
      label: "Français",
    },
    translation: {},
  },
  {
    config: {
      path: "ru",
      code: "ru",
      ogLang: "ru",
      name: "Russian",
      label: "Русский",
    },
    translation: {},
  },
]
